/**
 * ./src/landing/LeftBody.js
 * 
 * This component represents the left section (**visual roadmap**) of the landing page. 
 * It may include a visual representation of the user's learning journey, 
 * such as progress tracking or a step-based learning path.
 */


import React, { useEffect, useState } from 'react';
import './LeftBody.css'; // import 
// TO DO ADD API CALLS TO BACKEND TO lock excercises that users have yet to unlock



// Import all SVG files at the beginning
import blueCross from './icons/blue-cross.svg';
import flag from './icons/flag.svg';

// Import all lines
import line1 from './icons/line1.svg';
import line2 from './icons/line2.svg';
import line3 from './icons/line3.svg';
import line4 from './icons/line4.svg';
import line5 from './icons/line5.svg';
import line6 from './icons/line6.svg';
import line7 from './icons/line7.svg';
import line8 from './icons/line8.svg';
import line9 from './icons/line9.svg';

const LeftBody = ({ onFlagAppear, onCircleChange, flagCircleIndex = 0 }) => {
  const [enableExercise, setEnableExercise] = useState(10); // 10 exercises
  const [showElements, setShowElements] = useState(Array(20).fill(false));
  const [currentFlagCircleIndex, setCurrentFlagCircleIndex] = useState(0);

  // Calculate flag position based on circle index
  const getFlagPosition = (circleIndex) => {
    const circlePositions = [
      [-32, 44],   // 1st circle
      [-25, 162],  // 2nd circle
      [-2, 266],   // 3rd circle
      [79, 334],   // 4th circle
      [151, 263],  // 5th circle
      [171, 147],  // 6th circle
      [235, 42],   // 7th circle
      [320, 81]   // 8th circle
      //[353, 201],  // 9th circle
      //[360, 319]   // 10th circle
    ];
    
    return circlePositions[circleIndex] || [-2, 266];
  };

  // Helper function to determine circle style
  const getCircleStyle = (index) => {
    if (index === currentFlagCircleIndex) return 'bordered';
    if (index < enableExercise) return 'blue';
    return 'grey';
  };

  // Helper function to determine line style
  const getLineStyle = (index) => {
    return index < enableExercise - 1 ? 'blue' : 'grey';
  };

  const [flagTop, flagLeft] = getFlagPosition(currentFlagCircleIndex);
  
  useEffect(() => {
    let timer = 0;
    showElements.forEach((_, index) => {
      setTimeout(() => {
        setShowElements(prev => {
          const newState = [...prev];
          newState[index] = true;
          return newState;
        });

        if (index === 19) {
          onFlagAppear();
        }
      }, timer);
      timer += 100;
    });
  }, [onFlagAppear]);

  const handleCircleClick = (index) => {
    if (index < enableExercise) {
      setCurrentFlagCircleIndex(index);
      onCircleChange(index);
    }
  };

  return (
    <div className="left-body">
      {/* First Circle */}
      <div
        className={`circle ${getCircleStyle(0)} ${showElements[0] ? 'dissolve' : ''} ${currentFlagCircleIndex === 0 ? 'has-flag' : ''}`}
        onClick={() => handleCircleClick(0)}
      ></div>
      <img src={line1} alt="line 1" className={`line ${getLineStyle(0)} ${showElements[1] ? 'dissolve' : ''}`} />

      {/* Second Circle */}
      <div
        className={`circle ${getCircleStyle(1)} ${showElements[2] ? 'dissolve' : ''} ${currentFlagCircleIndex === 1 ? 'has-flag' : ''}`}
        onClick={() => handleCircleClick(1)}
      ></div>
      <img src={line2} alt="line 2" className={`line ${getLineStyle(1)} ${showElements[3] ? 'dissolve' : ''}`} />

      {/* Third Circle */}
      <div
        className={`circle ${getCircleStyle(2)} ${showElements[4] ? 'dissolve' : ''} ${currentFlagCircleIndex === 2 ? 'has-flag' : ''}`}
        onClick={() => handleCircleClick(2)}
      ></div>
      <img src={line3} alt="line 3" className={`line ${getLineStyle(2)} ${showElements[5] ? 'dissolve' : ''}`} />

      {/* Fourth Circle */}
      <div
        className={`circle ${getCircleStyle(3)} ${showElements[6] ? 'dissolve' : ''} ${currentFlagCircleIndex === 3 ? 'has-flag' : ''}`}
        onClick={() => handleCircleClick(3)}
      ></div>
      <img src={line4} alt="line 4" className={`line ${getLineStyle(3)} ${showElements[7] ? 'dissolve' : ''}`} />

      {/* Fifth Circle */}
      <div className={`circle ${getCircleStyle(4)} ${showElements[8] ? 'dissolve' : ''} ${currentFlagCircleIndex === 4 ? 'has-flag' : ''}`}
      onClick={() => handleCircleClick(4)}
      ></div>
      <img src={line5} alt="line 5" className={`line ${getLineStyle(4)} ${showElements[9] ? 'dissolve' : ''}`} />

      {/* Sixth Circle */}
      <div className={`circle ${getCircleStyle(5)} ${showElements[10] ? 'dissolve' : ''} ${currentFlagCircleIndex === 5 ? 'has-flag' : ''}`}
      onClick={() => handleCircleClick(5)}
      ></div>
      <img src={line6} alt="line 6" className={`line ${getLineStyle(5)} ${showElements[11] ? 'dissolve' : ''}`} />

      {/* Seventh Circle */}
      <div className={`circle ${getCircleStyle(6)} ${showElements[12] ? 'dissolve' : ''} ${currentFlagCircleIndex === 6 ? 'has-flag' : ''}`}
      onClick={() => handleCircleClick(6)}
      ></div>
      <img src={line7} alt="line 7" className={`line ${getLineStyle(6)} ${showElements[13] ? 'dissolve' : ''}`} />

      {/* Eighth Circle */}
      <div className={`circle ${getCircleStyle(7)} ${showElements[14] ? 'dissolve' : ''} ${currentFlagCircleIndex === 7 ? 'has-flag' : ''}`}
      onClick={() => handleCircleClick(7)}
      ></div>
      {/* <img src={line8} alt="line 8" className={`line ${getLineStyle(7)} ${showElements[15] ? 'dissolve' : ''}`} /> */}

      {/* Ninth Circle */}
      {/* <div className={`circle ${getCircleStyle(8)} ${showElements[16] ? 'dissolve' : ''} ${currentFlagCircleIndex === 8 ? 'has-flag' : ''}`}
      onClick={() => handleCircleClick(8)}
      ></div>
      <img src={line9} alt="line 9" className={`line ${getLineStyle(8)} ${showElements[17] ? 'dissolve' : ''}`} /> */}

      {/* Tenth Circle */}
      {/* <div className={`circle ${getCircleStyle(9)} ${showElements[18] ? 'dissolve' : ''} ${currentFlagCircleIndex === 9 ? 'has-flag' : ''}`}
      onClick={() => handleCircleClick(9)}
      ></div> */}
     
      {/* Blue Cross */}
      {/* <img src={blueCross} alt="cross" className={`cross ${showElements[18] ? 'dissolve' : ''}`} /> */}

      {/* Flag */}
      <img 
        src={flag} 
        alt="flag" 
        className={`flag ${showElements[19] ? 'dissolve' : ''}`}
        style={{
          top: `${flagTop}px`,
          left: `${flagLeft}px`
        }}
      />

    </div>
  );
};

export default LeftBody;